export const SOFTLINE_PERMISSION_DASHBOARD = 'DASHBOARD';
